const months = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

const weekDays = [
  { name: 'sunday', isWeekend: true },
  { name: 'monday' },
  { name: 'tuesday' },
  { name: 'wednesday' },
  { name: 'thursday' },
  { name: 'friday' },
  { name: 'saturday', isWeekend: true },
];

const getLocaleWeekDay = (intl, weekDay) => {
  return {
    ...weekDay,
    name: intl.formatMessage({ id: `TIME.${weekDay.name.toUpperCase()}` }),
    short: intl.formatMessage({
      id: `TIME.SHORT_${weekDay.name.toUpperCase()}`,
    }),
  };
};

const getLocaleWeekDays = (intl) => {
  const parsedWeekDays = weekDays.map((weekDay) =>
    getLocaleWeekDay(intl, weekDay)
  );

  const firstDayOfWeek = intl.formatMessage({
    id: 'TIME.FIRST_DAY_OF_WEEK',
  });

  const firstDayIndex = parsedWeekDays.findIndex(
    (day) => day.name.toLowerCase() === firstDayOfWeek.toLowerCase()
  );

  return [
    ...parsedWeekDays.slice(firstDayIndex),
    ...parsedWeekDays.slice(0, firstDayIndex),
  ];
};

const getLocaleMonth = (intl, month) => {
  return intl.formatMessage({ id: `TIME.${month.toUpperCase()}` });
};

const getLocaleMonths = (intl) => {
  return months.map((m) => getLocaleMonth(intl, m));
};

export const getCalendarLocale = (intl) => {
  return {
    //
    months: getLocaleMonths(intl),
    weekDays: getLocaleWeekDays(intl),
    weekStartingIndex: 0,

    //
    nextMonth: intl.formatMessage({ id: 'TIME.NEXT_MONTH' }),
    previousMonth: intl.formatMessage({ id: 'TIME.PREV_MONTH' }),
    openMonthSelector: intl.formatMessage({ id: 'TIME.OPEN_MONTH' }),
    openYearSelector: intl.formatMessage({ id: 'TIME.OPEN_YEAR' }),
    closeMonthSelector: intl.formatMessage({ id: 'TIME.CLOSE_MONTH' }),
    closeYearSelector: intl.formatMessage({ id: 'TIME.CLOSE_YEAR' }),
    defaultPlaceholder: intl.formatMessage({
      id: 'TIME.DEFAULT_PLACEHOLDER',
    }),

    //
    from: intl.formatMessage({ id: 'TIME.FROM' }),
    to: intl.formatMessage({ id: 'TIME.TO' }),

    //
    isRtl: false,

    //
    getToday(gregorianTodayObject) {
      return gregorianTodayObject;
    },
    toNativeDate(date) {
      return new Date(date.year, date.month - 1, date.day);
    },
    getMonthLength(date) {
      return new Date(date.year, date.month, 0).getDate();
    },
    transformDigit(digit) {
      return digit;
    },
    digitSeparator: ',',
    yearLetterSkip: 0,
  };
};
